<template>
  <button
    :class="
      `ml-1 box-border h-10 bg-white border-4 border-${color} disabled:opacity-50 disabled:bg-black`
    "
    style="width:180px"
    type="button"
    v-bind="$attrs"
  >
    <div class="flex flex-row items-center justify-center">
      <BackArrow :class="`${color}-icon`"></BackArrow>
      <div class="flex flex-row items-baseline">
        <span :class="`text-${color} text-lg font-bold leading-tight`">
          入力
        </span>
        <span :class="`text-${color} text-sm font-bold leading-tight`">に</span>
        <span :class="`text-${color} text-lg font-bold leading-tight`">
          戻
        </span>
        <span :class="`text-${color} text-sm font-bold leading-tight`">
          る
        </span>
      </div>
    </div>
  </button>
</template>

<script>
import BackArrow from '@/assets/icons/back-arrow.svg?inline'
export default {
  name: 'AppShowOfficeBtn',
  components: {
    BackArrow,
  },

  props: {
    color: String,
  },
}
</script>

<style lang="scss" scoped>
button {
  border-radius: 20px;
  width: 512px;
  &:disabled {
    div {
      svg {
        fill: black;
        circle {
          fill: #b8a000;
        }
      }
    }
  }
}
</style>
